var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1792,
    height: 1792,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 402,
    width: 582,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_1",
    d: "m1024,1375l0,-190q0,-14 -9.5,-23.5t-22.5,-9.5l-192,0q-13,0 -22.5,9.5t-9.5,23.5l0,190q0,14 9.5,23.5t22.5,9.5l192,0q13,0 22.5,-9.5t9.5,-23.5zm-2,-374l18,-459q0,-12 -10,-19q-13,-11 -24,-11l-220,0q-11,0 -24,11q-10,7 -10,21l17,457q0,10 10,16.5t24,6.5l185,0q14,0 23.5,-6.5t10.5,-16.5zm-14,-934l768,1408q35,63 -2,126q-17,29 -46.5,46t-63.5,17l-1536,0q-34,0 -63.5,-17t-46.5,-46q-37,-63 -2,-126l768,-1408q17,-31 47,-49t65,-18t65,18t47,49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.22d7f8e16bf7e0a240d160b9e8e1066f.svg";
export { ForwardRef as ReactComponent };